import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import CursosConcluidos from './CursosConcluidos';
import Especialidades from './Especialidades';
import SobreUsuario from './SobreUsuario';
import IndicacaoPlano from './IndicacaoPlano';
import Planos from './Planos';
import Recibos from './Recibos';
import Termos from './Termos';
import { Creators as ProfileActions } from '../../store/ducks/user/profile/actions';
import { Creators as OnboardingActions } from '../../store/ducks/onboarding/actions';
import { ButtonContainer, ButtonConfirm } from './styles';
import {
  toastErrorAndWarningOptions,
  toastDefaultOptions
} from '../../utils/functions';
import { ONBOARDING_PAGES } from '../../utils/constants';
import OnboardingPageFormationsExperiences from '../Onboarding/components/OnboardingPageFormationsExperiences';
import OnboardingPageListbox from '../Onboarding/components/OnboardingPageListBox';
import ContainerCollapse from './components/ContainerCollapse';
import OnboardingPageDynamic from '../Onboarding/components/OnboardingPageDynamic';
import { useOnboardingPages } from './context/OnboardingPagesContext';

const Sobre = ({ setOnboardingPages }) => {
  const [endOfMonth, setEndOfMonth] = useState('');
  const [showPlanos, setShowPlanos] = useState(true);
  const [
    onboardingDataFormationsExperiences,
    setOnboardingDataFormationsExperiences
  ] = useState('');
  const [onboardingDataListbox, setOnboardingDataListbox] = useState('');
  const [onboardingDataGoals, setOnboardingDataGoals] = useState('');
  const [onboardingDataInterests, setOnboardingDataInterests] = useState('');
  const currentPageRef = useRef();
  const tenant = localStorage.getItem('tenant');
  const settings = JSON.parse(localStorage.getItem('settings'))[tenant];
console.log("settings", settings)
  const { pages, hasOnboardingPages, refetchPages } = useOnboardingPages();

  useEffect(() => {
    if (!pages.length) return;

    const normalizedPages = pages.map(page => {
      if (!page.bf_concluded) {
        return { ...page, bf_concluded: false };
      }
      return page;
    });

    const formationsExperiences = normalizedPages.find(
      page => page.wx_page === ONBOARDING_PAGES.FORMATIONS_EXPERIENCES
    );
    const listbox = normalizedPages.find(
      page => page.wx_page === ONBOARDING_PAGES.LISTBOX
    );
    const goals = normalizedPages.find(page => page.wx_page === ONBOARDING_PAGES.GOALS);
    const interests = normalizedPages.find(page => page.wx_page === ONBOARDING_PAGES.INTERESTS);
    const interestIndex = normalizedPages.findIndex(page => page.wx_page === ONBOARDING_PAGES.INTERESTS);

    setOnboardingDataFormationsExperiences(formationsExperiences);
    setOnboardingDataListbox(listbox);
    setOnboardingDataGoals(goals);
    setOnboardingPages(normalizedPages);
    setOnboardingDataInterests({ ...interests, index: interestIndex });
  }, [pages]);

  async function advancePage(currentPageIndex) {
    if (currentPageIndex === -1) {
      return;
    }
    if (currentPageRef.current) {
      try {
        await currentPageRef.current.saveForm();
        toast.success(
          'Informações atualizadas com sucesso',
          toastDefaultOptions
        );
      } catch (e) {
        if (e.response && e.response.data) {
          const errorMessage = e.response.data.error;
          if (typeof currentPageRef.current.showErrors === 'function') {
            currentPageRef.current.showErrors(e.response.data.error);
          }
          toast.warn(errorMessage, toastErrorAndWarningOptions);
        }
      }
    }
  }

  async function savePageDynamic() {
    try {
      await advancePage(3);
    } catch (e) {
      if (e.response && e.response.data) {
        const errorMessage = e.response.data.error;

        toast.warn(errorMessage, toastErrorAndWarningOptions);
      }
    }
  }

  async function savePageFormationsExperiences() {
    try {
      await advancePage(2);
    } catch (e) {
      if (e.response && e.response.data) {
        const errorMessage = e.response.data.error;

        toast.warn(errorMessage, toastErrorAndWarningOptions);
      }
    }
  }

  async function savePageListbox() {
    try {
      await advancePage(3);
    } catch (e) {
      if (e.response && e.response.data) {
        const errorMessage = e.response.data.error;

        toast.warn(errorMessage, toastErrorAndWarningOptions);
      }
    }
  }

  return (
    <>
      <CursosConcluidos />
      {hasOnboardingPages && (
        <Especialidades
          interests={onboardingDataInterests}
          refetchOnboarding={refetchPages}
        />
      )}

      <SobreUsuario />
      {onboardingDataFormationsExperiences && (
        <ContainerCollapse
          title="Sua Formação e Experiência"
          emptyTitle="Nenhuma formação e experiência cadastrada"
          content={
            <>
              <OnboardingPageFormationsExperiences
                index={2}
                data={onboardingDataFormationsExperiences}
                ref={currentPageRef}
                isVisibleTitle={false}
              />
              <ButtonContainer>
                <ButtonConfirm
                  onClick={savePageFormationsExperiences}
                  type="button"
                >
                  Salvar
                </ButtonConfirm>
              </ButtonContainer>
            </>
          }
        />
      )}

      {onboardingDataListbox && (
        <ContainerCollapse
          title="Preferências de Estudo"
          emptyTitle="Nenhuma preferência cadastrada"
          content={
            <>
              <OnboardingPageListbox
                index={3}
                data={onboardingDataListbox}
                ref={currentPageRef}
                isVisibleTitle={false}
                savePageListbox={savePageListbox}
              />
              <ButtonContainer>
                <ButtonConfirm onClick={savePageListbox} type="button">
                  Salvar
                </ButtonConfirm>
              </ButtonContainer>
            </>
          }
        />
      )}

      {onboardingDataGoals && (
        <>
          <ContainerCollapse
            title="Suas Metas de Estudos"
            emptyTitle="Nenhuma meta e estudo cadastrado"
            content={
              <OnboardingPageDynamic
                index={4}
                data={onboardingDataGoals}
                questions={onboardingDataGoals.qx_dynamicquestions}
                previousAnswers={onboardingDataGoals.qx_dynamicquestions}
                ref={currentPageRef}
                isVisibleTitle={false}
                savePageDynamic={savePageDynamic}
              />
            }
          />
        </>
      )}

      {_.get(settings, 'profile.showDiscountIndicating', 'true') === 'true' && (
        <IndicacaoPlano />
      )}
      {_.get(settings, 'profile.showSignature', 'true') === 'true' && showPlanos && (
        <Planos
          setEndOfMonth={value => setEndOfMonth(value)}
          onDataLoaded={setShowPlanos}
        />
      )}
      {_.get(settings, 'profile.showPayments', 'true') === 'true' && (
        <Recibos endOfMonth={endOfMonth} />
      )}
      <Termos />
    </>
  );
};

const mapStateToProps = state => ({
  data: state.onboarding.onboardingData,
  previousAnswersGoals: state.onboarding.previousAnswersGoals,
  previousAnswersIterests: state.onboarding.previousAnswersIterests
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...ProfileActions,
      ...OnboardingActions
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Sobre);
